import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './bazaarvoice-review-unavailable.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
function BazaarvoiceReviewUnavailableComponent() {
  const $ = _c(4);
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  let t0;
  if ($[0] !== formatMessage) {
    t0 = formatMessage("unavailableStateMessage");
    $[0] = formatMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className={styles["bazaarvoice-review-unavailable"]} role="status"><p className={styles["bazaarvoice-review-unavailable__message"]}>{t0}</p></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default memo(BazaarvoiceReviewUnavailableComponent);